"use client";

/**
 * next/link plus the page-change spin (lib/nav-pending): same props, same
 * behaviour, and the header's mark turns while the new page loads.
 * Use it wherever next/link was imported directly; LocalizedLink does the
 * same for the locale-prefixed links.
 */
import Link from "next/link";
import type { ComponentProps } from "react";
import { withNavigationSpin } from "@/lib/nav-pending";

export default function NavLink({ onNavigate, ...props }: ComponentProps<typeof Link>) {
  return <Link {...props} onNavigate={withNavigationSpin(props.href, onNavigate)} />;
}
